import { scrubText } from "./scrub";

type Level = "debug" | "info" | "warn" | "error";
const order: Record<Level, number> = { debug: 0, info: 1, warn: 2, error: 3 };
const threshold: Level = import.meta.env.DEV ? "debug" : "warn";

function emit(level: Level, message: string, context?: unknown) {
  if (order[level] < order[threshold]) return;
  const text = scrubText(message);
  const extra =
    context === undefined
      ? []
      : [scrubText(typeof context === "string" ? context : safeJson(context))];
  // eslint-disable-next-line no-console -- the one place console is allowed
  console[level === "debug" ? "debug" : level](`[${level}] ${text}`, ...extra);
}

const safeJson = (v: unknown) => {
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
};

/** Leveled, scrubbed logging. Never pass file contents; URLs are scrubbed but still best left out. */
export const logger = {
  debug: (m: string, c?: unknown) => emit("debug", m, c),
  info: (m: string, c?: unknown) => emit("info", m, c),
  warn: (m: string, c?: unknown) => emit("warn", m, c),
  error: (m: string, c?: unknown) => emit("error", m, c),
};
